import { PALETTE, FONT_MONO, FONT_DISPLAY } from "./tokens";

/* Vertical-agnostic logo marquee. Uses styled wordmarks rather than
   real logos (these are illustrative industry placeholders for the
   beta cohort, not real customer logos). Mirrors the homepage
   marquee pattern with pause-on-hover. */

const ROW = [
  { name: "Trades",  sub: "field service" },
  { name: "Dental",  sub: "specialty practice" },
  { name: "Legal",   sub: "boutique firms" },
  { name: "Agency",  sub: "perf marketing" },
  { name: "Roofing", sub: "exteriors" },
  { name: "MedSpa",  sub: "wellness" },
  { name: "Retail",  sub: "multi-store" },
  { name: "Consult", sub: "small pro teams" },
];

export const PartnerMarquee = ({ variant = "cobrain" }: { variant?: "cobrain" | "services" }) => (
  <div style={{
    position: "relative", overflow: "hidden",
    padding: "20px 0",
    background: PALETTE.bg,
    borderTop: `1px solid ${PALETTE.line}`,
    borderBottom: `1px solid ${PALETTE.line}`,
  }}>
    <style>{`
      @keyframes cb-marquee { 0% { transform: translateX(0) } 100% { transform: translateX(-50%) } }
      .cb-marquee-track { animation: cb-marquee 38s linear infinite; will-change: transform; }
      .cb-marquee-track:hover { animation-play-state: paused; }
      @media (prefers-reduced-motion: reduce) { .cb-marquee-track { animation: none; } }
    `}</style>
    <div aria-hidden style={{
      position: "absolute", top: 0, bottom: 0, left: 0, width: 80, zIndex: 2,
      background: `linear-gradient(90deg, ${PALETTE.bg}, transparent)`, pointerEvents: "none",
    }} />
    <div aria-hidden style={{
      position: "absolute", top: 0, bottom: 0, right: 0, width: 80, zIndex: 2,
      background: `linear-gradient(270deg, ${PALETTE.bg}, transparent)`, pointerEvents: "none",
    }} />
    <div className="cb-marquee-track" style={{ display: "flex", gap: 56, width: "max-content" }}>
      {[...ROW, ...ROW].map((r, i) => (
        <div key={i} style={{ display: "inline-flex", alignItems: "baseline", gap: 10, flexShrink: 0 }}>
          <span style={{
            fontFamily: FONT_DISPLAY, fontStyle: "italic", fontSize: 22,
            color: PALETTE.ink, fontWeight: 400, lineHeight: 1,
          }}>{r.name}</span>
          <span style={{
            fontFamily: FONT_MONO, fontSize: 10, letterSpacing: "0.12em",
            textTransform: "uppercase", color: PALETTE.muted, fontWeight: 700,
          }}>{r.sub}</span>
        </div>
      ))}
    </div>
    <div style={{
      textAlign: "center", marginTop: 12,
      fontFamily: FONT_MONO, fontSize: 10.5, letterSpacing: "0.16em",
      textTransform: "uppercase", color: PALETTE.muted, fontWeight: 700,
    }}>
      {variant === "services" ? "Verticals we build for · representative" : "Beta cohort verticals · representative"}
    </div>
  </div>
);
